import React from 'react';
import driversIcon from '../../../../../assets/svg/driver.svg';

const NoDrivers = () => {
  return (
    <div style={{ textAlign: 'center', marginTop: 100 }}>
      <img src={driversIcon} alt="سفارشی یافت نشد." height={60} width={60} />
      <div>راننده ای یافت نشد.</div>
    </div>
  );
};

export default React.memo(NoDrivers);
